import PropTypes from "prop-types";

import { Grid, Paper, Typography } from "@mui/material";

import { formatDate, formatNumber } from "@/features/shared";

export const GeneralInformationSection = ({ purchasePayment }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">
            Informasi Pembayaran Pembelian
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Nomor Pembayaran
          </Typography>
          <Typography variant="body1">
            {purchasePayment.referenceNumber}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(purchasePayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Outlet Pembayar
          </Typography>
          <Typography variant="body1">
            {purchasePayment.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Pembayaran
          </Typography>
          <Typography variant="body1">
            {formatNumber(purchasePayment.grandTotal)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Catatan
          </Typography>
          <Typography variant="body1">{purchasePayment.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  purchasePayment: PropTypes.object.isRequired,
};
